import common from "./en/common.json";
import calculator from "./en/calculator.json";
import dashboard from "./en/dashboard.json";
import quotes from "./en/quotes.json";
import leads from "./en/leads.json";
import messages from "./en/messages.json";
import support from "./en/support.json";
import validation from "./en/validation.json";
import profile from "./en/profile.json";
import account from "./en/account.json";
import onboarding from "./en/onboarding.json";
import services from "./en/services.json";
import meetings from "./en/meetings.json";
import calendar from "./en/calendar.json";
import estimator from "./en/estimator.json";
import auth from "./en/auth.json";
import legal from "./en/legal.json";

// English is bundled because it is the fallback for every missing key; the
// other languages load on demand. Keys are not typed through i18next's
// CustomTypeOptions: on TS 4.9 that costs ~8M types and exhausts tsc's heap.
// `npm run i18n:check` validates the keys used in code instead.
export const enResources = {
  common,
  calculator,
  dashboard,
  quotes,
  leads,
  messages,
  support,
  validation,
  profile,
  account,
  onboarding,
  services,
  meetings,
  calendar,
  estimator,
  auth,
  legal,
} as const;
